import React, { Component } from "react";
import { StyleSheet, css } from "aphrodite";
import { Link } from "react-router";
import { Theme } from "../../config/theme.js";
import { guid } from "../../utils";
import { Helmet } from "react-helmet";

import {
  closeSearch,
  updateSearchQuery,
  fetchSearchResults
} from "../../actions/search";

import SearchOverlay from "../SearchOverlay";

export default class Body extends Component {
  constructor(props) {
    super(props);

    this.state = {
      latest_guid: null
    };
  }

  _unblur() {
    this.props.dispatch(closeSearch());
  }

  _updateSearchQuery(query) {
    this.props.dispatch(updateSearchQuery(query));

    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    if (query && query.length > 0) {
      this.searchTimeout = setTimeout(() => {
        const latestGuid = guid();
        this.setState({
          latest_guid: latestGuid
        });

        this.props
          .dispatch(fetchSearchResults(query, latestGuid))
          .then(response => {
            if (
              response.data.guid == this.state.latest_guid &&
              response.data.posts
            ) {
              this.props.dispatch({
                type: "REPLACE_SEARCH_RESULTS",
                payload: response.data.posts
              });
            }
          });
      }, 200);
    } else {
      this.props.dispatch({
        type: "REPLACE_SEARCH_RESULTS",
        payload: []
      });
    }
  }

  render() {
    const searchOpen = this.props.search && this.props.search.open;

    const paddingBottom =
      this.props.player.queue && this.props.player.queue.length
        ? Theme.player.height
        : 0;

    const styles = StyleSheet.create({
      body: {
        fontFamily: Theme.fontFamily,
        backgroundColor: Theme.light_background,
        paddingTop: Theme.navigation.height,
        minHeight:
          window.innerHeight - (Theme.navigation.height + Theme.player.height),
        paddingBottom: paddingBottom,
        width: "100vw",
        maxWidth: "100vw",
        overflowX: "hidden",
        transition: "filter 240ms ease-in-out",
        [Theme.mobile_query]: {
          paddingBottom: 0,
          minHeight: window.innerHeight - Theme.navigation.height
        }
      },
      blurred: {
        filter: "blur(5px)"
      }
    });

    return (
      <div
        className={css(
          styles.body,
          this.props.style ? this.props.style : false
        )}
      >
        {this.props.title ? (
          <Helmet>
            <meta charSet="utf-8" />
            <title>{this.props.title ? this.props.title : `Sniffers`}</title>
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:site" content="@sniffersmag" />
            <meta property="twitter:creator" content="@sniffersmag" />
            <meta
              property="twitter:title"
              content={this.props.title ? this.props.title : `Sniffers`}
            />

            <meta
              property="og:title"
              content={this.props.title ? this.props.title : `Sniffers`}
            />
            <meta property="og:site_name" content="Sniffers" />
            {this.props.description ? (
              <meta name="description" content={this.props.description} />
            ) : (
              false
            )}
            {this.props.description ? (
              <meta
                name="twitter:description"
                content={this.props.description}
              />
            ) : (
              false
            )}
            {this.props.description ? (
              <meta
                property="og:description"
                content={
                  this.props.summary
                    ? this.props.summary
                    : this.props.description
                }
              />
            ) : (
              false
            )}
            {this.props.image ? (
              <meta property="og:image" content={this.props.image} />
            ) : (
              false
            )}
            {this.props.image ? (
              <meta property="twitter:image" content={this.props.image} />
            ) : (
              false
            )}
          </Helmet>
        ) : (
          false
        )}
        <div className={css(searchOpen ? styles.blurred : false)}>
          {this.props.children}
        </div>
        {searchOpen ? (
          <SearchOverlay
            history={this.props.history}
            results={this.props.search.results}
            queryHandler={this._updateSearchQuery.bind(this)}
            query={this.props.search.query}
            closeHandler={this._unblur.bind(this)}
          />
        ) : (
          false
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Body/index.js